import { Route, Routes } from "react-router";
import AppWrapper from "../../AppWrapper";
import AuthAuthorize from "./Authorize";
import AuthChangePassword from "./ChangePassword";
import SwitchPage from "./SwitchPage";
import AuthLogin from "./Login";
import AuthRegister from "./Register";
import AuthLogout from "./Logout";
import AuthResetPassword from "./ResetPassword";
import AuthActivate from "./Activate";

function AuthRoutes() {
  return (
    <Routes>
      <Route
        path="authorize"
        element={
          <AppWrapper>
            <AuthAuthorize />
          </AppWrapper>
        }
      />
      <Route
        path="changepassword"
        element={
          <AppWrapper>
            <AuthChangePassword />
          </AppWrapper>
        }
      />
      <Route path="switch" element={<SwitchPage />} />
      <Route path="login" element={<AuthLogin />} />
      <Route path="register" element={<AuthRegister />} />
      <Route path="logout" element={<AuthLogout />} />
      <Route path="resetpassword" element={<AuthResetPassword />} />
      <Route path="activate" element={<AuthActivate />} />
    </Routes>
  );
}

export default AuthRoutes;
